export const ROLES = {
  LITE: 'Lite',
  PREMIUM: 'Premium',
  PLUS: 'Plus',
  ADMIN: 'Admin',
  TESTER: 'Tester',
};
